import { captureEvent } from "@Light/app/analytics";
import { Button, type ButtonSize } from "@Light/components/page/Button";
import { useSupportBottomSheet } from "@Light/components/page/SupportBottomSheet";
import { ButtonFooter } from "../page/ButtonFooter";

type EnrollHelpButtonProps = {
  children?: React.ReactNode;
  eventVariant?: string;
  size?: ButtonSize;
  onClick?: (ev: React.MouseEvent<HTMLElement>) => void;
  "data-testid"?: string;
};

export const EnrollHelpButton = ({
  children = "Have a question?",
  eventVariant = "footer",
  size = "lg",
  onClick,
  ...props
}: EnrollHelpButtonProps) => {
  const openSupport = useSupportBottomSheet();

  return (
    <Button
      size={size}
      buttonType="clear"
      onClick={(ev) => {
        onClick?.(ev);
        if (ev.defaultPrevented) return;
        captureEvent("support_button_clicked", { variant: eventVariant });
        openSupport();
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

type EnrollHelpButtonFooterProps = {
  children?: React.ReactNode;
  disclaimer?: React.ReactNode;
  /** Label of the support button. */
  helpButtonText?: React.ReactNode;
  /** Distinguishes the button in `support_button_clicked` analytics. */
  helpButtonEventVariant?: string;
  helpButtonTestId?: string;
};

export const EnrollHelpButtonFooter = ({
  children,
  disclaimer,
  helpButtonText = "Have a question?",
  helpButtonEventVariant = "footer",
  helpButtonTestId,
}: EnrollHelpButtonFooterProps) => (
  <ButtonFooter disclaimer={disclaimer}>
    {children}
    <EnrollHelpButton
      eventVariant={helpButtonEventVariant}
      data-testid={helpButtonTestId}
    >
      {helpButtonText}
    </EnrollHelpButton>
  </ButtonFooter>
);
